import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from "codelyzer/util/isNotNullOrUndefined";
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { GridElement } from 'src/app/_models/grid-element';
import { MapService } from "../map/map.service";
import { Condition } from 'src/app/_models/condition';
import { Property } from 'src/app/_models/property';
import { Cable } from 'src/app/_models/cable';
import { StartEndsList } from 'src/app/_models/start-end-list';
import { StartEnd } from 'src/app/_models/start-end';
import { CableDetails } from 'src/app/_models/cable-details';
import { Config } from '../../config';
import { CableProperty } from '../../_models/cable-property';
import { GridElementDetails } from '../../_models/grid-element-details';
import { TopologyConfig } from 'src/app/_models/topology-list';
import { E } from '@angular/cdk/keycodes';


@Injectable({
  providedIn: 'root'
})
export class GPlanService {

  private nodesMap: Map<number, GridElement> = new Map<number, GridElement>();
  private nodeNameList: string[];
  private cableFromNameList: string[];
  // private cableStartEndMap: StartEnds[];
  private cableTypeNameList: string[];
  private cableProperties: CableProperty[];
  private cables: Array<Cable> = new Array<Cable>();
  // private cablesMap: Map<number, Cable> = new Map<number, Cable>();
  private cableDetailsList: Array<CableDetails> = new Array<CableDetails>();
  private startEndsList: StartEndsList;
  times = 0;
  // private topologyId = Config.TOPOLOGY_ID;
  private topology: TopologyConfig;

  private isGplanFinishedWithErrorVariable: boolean = false;

  // private alreadyCheckedScenariosID: Array<number> = new Array<number>();
  // scenarioChecker: boolean = false; 


  //sharing selected Scenario data between components
  private sharedData = new BehaviorSubject<{ scenarioId: number, scenarioName: string, 
    scenarioIntervalStart: string, scenarioIntervalEnd: string, scenarioType: string}>({scenarioId: 0, scenarioName: "", 
      scenarioIntervalStart: "", scenarioIntervalEnd: "", scenarioType: ""});
  sharedSelectedScenarioID$ = this.sharedData.asObservable();

  public isTrafoTabChecked: boolean = true;

  // private nodeOrTrafoTab = new BehaviorSubject<number>(0);
  // nodeOrTrafoTab$ = this.nodeOrTrafoTab.asObservable();
  // private sharedScenarioName = new BehaviorSubject<any>("");
  // sharedScenarioName$ = this.sharedScenarioName.asObservable();
  // sharedSelectedScenarioId:number;

  constructor(
    private http: HttpClient,
    private mapService: MapService) { }

  isGPlanRunning() {
    let isGPlanRunning: boolean = false;

    const isGPlanRunningStr: string = localStorage.getItem("isGPlanRunning");
    if (isNotNullOrUndefined(isGPlanRunningStr)) {
      if (isGPlanRunningStr === "true") {
        isGPlanRunning = true;
      }
    }

    return isGPlanRunning;
  }

  isGPlanFinishedWithError(){
    this.isGplanFinishedWithErrorVariable = true;
  }

  getIsGplanFinishedWithError(): boolean{
    return this.isGplanFinishedWithErrorVariable;
  }

  setGPlanRunning(isRunning: boolean) {
    localStorage.setItem("isGPlanRunning", "" + isRunning);
  }

  setGplanDataAvailable(areGplanDataAvailable: boolean) {
    localStorage.setItem("areGplanDataAvailable", "" + areGplanDataAvailable);
  }

  areGplanDataAvailable() {
    let areGplanDataAvailable: boolean = false;

    const areGplanDataAvailableStr: string = localStorage.getItem("areGplanDataAvailable");
    if (isNotNullOrUndefined(areGplanDataAvailableStr)) {
      if (areGplanDataAvailableStr == "true") {
        areGplanDataAvailable = true;
      }
    }
    return areGplanDataAvailable;
  }

  getGplanNode(topologyId: any, date: string) {
    const gplanNodeJson = localStorage.getItem("gplanNodes");
    const gridElementDetailsLoc: Array<GridElementDetails> = JSON.parse(gplanNodeJson);
    if (gplanNodeJson && gridElementDetailsLoc.length > 0) {
      return;
    }
    if (date) {
      this.mapService.getGPlanNodeDetailsTimeDependant(topologyId, date).subscribe(
        (gridElementDetails: Array<GridElementDetails>) => {
          localStorage.setItem("gplanNodes", JSON.stringify(gridElementDetails));
        },
        (e) => {
          console.error(e);
        });
    }
    else {
      this.mapService.getGPlanNodeDetails(topologyId).subscribe(
        (gridElementDetails: Array<GridElementDetails>) => {
          localStorage.setItem("gplanNodes", JSON.stringify(gridElementDetails));
        },
        (e) => {
          console.error(e);
        });
    }

  }

  public getListAvailableScenarios() {
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    return this.http.get(environment.API_BASE_URL + "gridplanning/listAvaiableScenarios/" + this.topology.topologyId);
  }

  // This method is used to get the list of available scenarios for the overall results (LA Planning, GMON Planning, Planning Overview)
  public getListAvailableScenariosForOverallResults(topologyId: string){
    return this.http.get(environment.API_BASE_URL + "gridplanning/listAvaiableScenarios/" + topologyId);
  }

  public getGPSummaryInfo(selectedScenarioID: number){
    return this.http.get(environment.API_BASE_URL + "application/gp/summary/" + selectedScenarioID);
  }

  setSharedData(data: {scenarioId: number, scenarioName: string, scenarioIntervalStart: string, scenarioIntervalEnd: string, scenarioType: string}){
    this.sharedData.next(data);
    // this.sharedScenarioName.next(sharedScenarioName);
  }

  // setNodeOrTrafoTabNumber(data: number){
  //   this.nodeOrTrafoTab.next(data);
  // }

  isTrafoTabClicked(){
    this.isTrafoTabChecked = !this.isTrafoTabChecked;
  }

  public deleteGplanScenario(scenarioId: number) {
    return this.http.delete(`${environment.API_BASE_URL}gridplanning/deleteScenario/${scenarioId}`, {
      responseType: 'text'
    });
  }


  //=================The condition when the two identical scenarios can not be called twice===== SHOULD FINISH

  // checkingIsTheScenarionAlreadyChecked(checkingScenarioId: string){
  //   if(!this.alreadyCheckedScenariosID.includes(checkingScenarioId)){
  //     this.alreadyCheckedScenariosID.push(checkingScenarioId);
  //     this.scenarioChecker = true;
  //     console.log("checking the array of already added scenarios ", this.alreadyCheckedScenariosID)
  //   }else{
  //     this.scenarioChecker = false;
  //   }
  // }

  // getSelectedScenarioID(){
  //   // return this.sharedSelectedScenarioId;
  // }

}




